module.exports = __webpack_public_path__ + "img/19_11.ed71465a.png";